import React from "react";
import styled from "styled-components";

import Header from ".";
import EkomiFlag from "../EkomiFlag";
import IconCircle from "../IconCircle";
import CrownIcon from "../Icons/CrownIcon";

const CssReset = styled.div`
  position: relative;
  width: 100%;
  overflow-x: scroll;
  height: 200px;
  & ul,
  li {
    margin-left: 0 !important;
    margin-bottom: 0 !important;
  }
  img {
    margin-bottom: 0 !important;
  }
`;

const HeaderExample: React.FC<React.PropsWithChildren<unknown>> = () => (
  <CssReset>
    <Header
      ekomiFlag={<EkomiFlag>Top eKomi-Bewertungen</EkomiFlag>}
      ekomiImageBig={
        <IconCircle color="brand">
          <CrownIcon color="brand" scale="huge" />
        </IconCircle>
      }
      ekomiImageSmall={
        <IconCircle color="brand">
          <CrownIcon color="brand" scale="huge" />
        </IconCircle>
      }
    />
  </CssReset>
);
export default HeaderExample;
